import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-6013">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-6014">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-6015">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-6016">
            <ArrowLeft className="w-4 h-4" data-id="element-6017" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-6018">NOIZA</div>
          <div className="w-20" data-id="element-6019" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-6020">
        <div className="mb-12" data-id="element-6021">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-6022">
            <FileText className="w-6 h-6 text-white/80" data-id="element-6023" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-6024">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-6025">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-6026">
          <section data-id="element-6027">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6028">
              <span className="text-[#006847]" data-id="element-6029">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6030">
              <p data-id="element-6031">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-6032">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6033">
                <li data-id="element-6034">Haber leído íntegramente este documento</li>
                <li data-id="element-6035">Comprender su contenido en su totalidad</li>
                <li data-id="element-6036">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-6037">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-6038">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6039">
              <span className="text-[#006847]" data-id="element-6040">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6041">
              <p data-id="element-6042">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6043">
                <li data-id="element-6044">Software como servicio (SaaS)</li>
                <li data-id="element-6045">Marketplace digital gastronómico</li>
                <li data-id="element-6046">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-6047">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6048">
                <li data-id="element-6049">Mostrar su menú digital</li>
                <li data-id="element-6050">Recibir pedidos de clientes</li>
                <li data-id="element-6051">Gestionar su operación interna</li>
                <li data-id="element-6052">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-6053">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-6054">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6055">
              <span className="text-[#006847]" data-id="element-6056">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6057">
              <p data-id="element-6058">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6059">
                <li data-id="element-6060">No es proveedor de alimentos</li>
                <li data-id="element-6061">No participa en la preparación de productos</li>
                <li data-id="element-6062">No manipula alimentos en ningún momento</li>
                <li data-id="element-6063">No realiza entregas ni logística</li>
                <li data-id="element-6064">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-6065">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-6066">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-6067">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6068">
              <span className="text-[#006847]" data-id="element-6069">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-6070">
              <p data-id="element-6071">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-6072">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6073">
                <li data-id="element-6074">El restaurante es el único responsable de su operación</li>
                <li data-id="element-6075">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-6076">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-6077">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6078">
                <li data-id="element-6079">Precios</li>
                <li data-id="element-6080">Menú</li>
                <li data-id="element-6081">Horarios</li>
                <li data-id="element-6082">Métodos de pago</li>
                <li data-id="element-6083">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6084">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6085">
              <span className="text-[#006847]" data-id="element-6086">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-6087">
              <div data-id="element-6088">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6089">
                  5.1. Alcance general
                </h3>
                <p data-id="element-6090">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-6091">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6092">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-6093">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6094">
                  <li data-id="element-6095">Calidad de los alimentos</li>
                  <li data-id="element-6096">Estado, frescura o preparación</li>
                  <li data-id="element-6097">Ingredientes utilizados</li>
                  <li data-id="element-6098">Contaminación cruzada</li>
                  <li data-id="element-6099">Problemas de higiene o salubridad</li>
                  <li data-id="element-6100">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6101">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-6102">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6103">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-6104">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6105">
                  <li data-id="element-6106">Retrasos en la entrega</li>
                  <li data-id="element-6107">Pérdida de pedidos</li>
                  <li data-id="element-6108">Entregas incompletas</li>
                  <li data-id="element-6109">Errores en dirección</li>
                  <li data-id="element-6110">Conducta de repartidores</li>
                  <li data-id="element-6111">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-6112">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6113">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-6114">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-6115">
                  <li data-id="element-6116">Recepción de pagos</li>
                  <li data-id="element-6117">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-6118">Manejo de efectivo</li>
                  <li data-id="element-6119">Confirmación de pagos</li>
                  <li data-id="element-6120">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-6121">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6122">
                  <li data-id="element-6123">Pagos no recibidos</li>
                  <li data-id="element-6124">Comprobantes falsos</li>
                  <li data-id="element-6125">Errores en montos</li>
                  <li data-id="element-6126">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-6127">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6128">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-6129">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6130">
                  <li data-id="element-6131">Reclamos de clientes</li>
                  <li data-id="element-6132">Reembolsos</li>
                  <li data-id="element-6133">Cancelaciones</li>
                  <li data-id="element-6134">Disputas</li>
                  <li data-id="element-6135">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6136">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-6137">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6138">
              <span className="text-[#006847]" data-id="element-6139">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-6140">
              <p data-id="element-6141">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6142">
                <li data-id="element-6143">Responsable</li>
                <li data-id="element-6144">Legal</li>
                <li data-id="element-6145">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-6146">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6147">
                <li data-id="element-6148">Publicar información falsa</li>
                <li data-id="element-6149">Manipular precios de forma engañosa</li>
                <li data-id="element-6150">Simular disponibilidad inexistente</li>
                <li data-id="element-6151">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6152">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6153">
              <span className="text-[#006847]" data-id="element-6154">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-6155">
              <p data-id="element-6156">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6157">
                <li data-id="element-6158">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-6159">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-6160">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6161">
                <li data-id="element-6162">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-6163">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-6164">
                    <li data-id="element-6165">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-6166">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-6167">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6168">
              <span className="text-[#006847]" data-id="element-6169">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-6170">
              <p data-id="element-6171">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6172">
                <li data-id="element-6173">Menú digital</li>
                <li data-id="element-6174">Gestión de pedidos</li>
                <li data-id="element-6175">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-6176">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6177">
                  <p className="font-medium text-white mb-2" data-id="element-6178">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6179">
                    <li data-id="element-6180">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6181">
                  <p className="font-medium text-white mb-2" data-id="element-6182">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6183">
                    <li data-id="element-6184">Propiedad del software</li>
                    <li data-id="element-6185">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-6186">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-6187">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6188">
              <span className="text-[#006847]" data-id="element-6189">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6190">
              <p data-id="element-6191">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6192">
                <li data-id="element-6193">Disponibilidad continua</li>
                <li data-id="element-6194">Funcionamiento sin interrupciones</li>
                <li data-id="element-6195">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-6196">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6197">
                <li data-id="element-6198">Fallas técnicas</li>
                <li data-id="element-6199">Actualizaciones</li>
                <li data-id="element-6200">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-6201">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-6202">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6203">
              <span className="text-[#006847]" data-id="element-6204">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-6205">
              <p data-id="element-6206">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6207">
                <li data-id="element-6208">No está garantizada permanentemente</li>
                <li data-id="element-6209">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-6210">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6211">
                <li data-id="element-6212">Destacar o no restaurantes</li>
                <li data-id="element-6213">Modificar posiciones</li>
                <li data-id="element-6214">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6215">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6216">
              <span className="text-[#006847]" data-id="element-6217">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-6218">
              <p data-id="element-6219">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6220">
                <li data-id="element-6221">Cumplir con los pagos acordados</li>
                <li data-id="element-6222">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-6223">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6224">
                <li data-id="element-6225">Suspender el servicio</li>
                <li data-id="element-6226">Limitar funcionalidades</li>
                <li data-id="element-6227">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6228">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6229">
              <span className="text-[#006847]" data-id="element-6230">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6231">
              <p data-id="element-6232">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6233">
                <li data-id="element-6234">Incumplimiento de términos</li>
                <li data-id="element-6235">Uso indebido</li>
                <li data-id="element-6236">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-6237">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-6238">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6239">
              <span className="text-[#006847]" data-id="element-6240">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-6241">
              <p data-id="element-6242">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-6243">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-6244">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6245">
              <span className="text-[#006847]" data-id="element-6246">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-6247">
              <p data-id="element-6248">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6249">
                <li data-id="element-6250">Pérdidas económicas</li>
                <li data-id="element-6251">Daños indirectos</li>
                <li data-id="element-6252">Lucro cesante</li>
                <li data-id="element-6253">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6254">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6255">
              <span className="text-[#006847]" data-id="element-6256">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-6257">
              <p data-id="element-6258">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-6259">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6260">
              <span className="text-[#006847]" data-id="element-6261">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-6262">
              <p className="font-medium" data-id="element-6263">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-6264">
                <li data-id="element-6265">Ha leído este documento completo</li>
                <li data-id="element-6266">Comprende su alcance</li>
                <li data-id="element-6267">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}